import React, { Component } from 'react';
import {Link} from 'react-router';
import Ionicon from 'react-ionicons';

export default class PreferencesSet extends Component {

    render() {

        const { network, ui } = this.props;
        const guestMode = ui;

        return (
           
            !guestMode && 

            <div className="row">
                <div className="col-xs-8 col-md-9">
                    <p className="p-tag">Change your <b>job alert</b> and <b>member search preferences</b>.</p>
                </div>
                <div className="col-xs-4 col-md-3">
                    <Link className="btn-inline-icon" type="button" to={`/${ network }/jobs/preferences`}>
                        <span className="share-label">PREFERENCES</span>
                        <span className="share-icon"><Ionicon icon="ion-settings"/></span>
                    </Link>
                </div>
            </div>
    
        )   
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/visibility/PreferencesSet.js